import { themeProvider } from '@swipejobs/frontend-theme-provider';
import styled from 'styled-components';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

export const Label = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const TickIcon = styled<typeof CheckCircleIcon>(CheckCircleIcon)`
  color: ${() => themeProvider.getColors().text.successTextMessage};
  margin-left: 5px;
`;

export const SendCodeMessage = styled.span`
  font-size: ${() => themeProvider.getTypography().font.size.medium};
`;



// WEBPACK FOOTER //
// ./src/screens/review-section3/pincode-authorisation/resend-code-label-styles.ts